export default __webpack_public_path__ + "static/media/foilIcon.6a433a60.svg";